import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "daily-sync-user-card" }
const _hoisted_2 = { class: "daily-sync-user-card__header" }
const _hoisted_3 = { class: "daily-sync-user-card__header__left" }
const _hoisted_4 = { class: "daily-sync-user-card__header__left__title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", null, "My daily sync⚡", -1)
const _hoisted_6 = { class: "p-small" }
const _hoisted_7 = { class: "daily-sync-user-card__header__right" }
const _hoisted_8 = { class: "daily-sync-user-card__content" }
const _hoisted_9 = { class: "daily-sync-user-card__main" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", null, "What are you working on today?", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "Team talk", -1)
const _hoisted_12 = { class: "daily-sync-user-card__activity" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAvatar = _resolveComponent("AppAvatar")!
  const _component_DailySyncMoodSelector = _resolveComponent("DailySyncMoodSelector")!
  const _component_DailySyncAvailabilitySelector = _resolveComponent("DailySyncAvailabilitySelector")!
  const _component_DailySyncTaskList = _resolveComponent("DailySyncTaskList")!
  const _component_AppTextEditor = _resolveComponent("AppTextEditor")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_ReactionDisplay = _resolveComponent("ReactionDisplay")!
  const _component_Conversation = _resolveComponent("Conversation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppAvatar, {
          user: _ctx.user.profile,
          size: "normal"
        }, null, 8, ["user"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.isSaving ? 'saving changes..' : _ctx.timeDiffCalc(_ctx.dailySync.lastUpdatedAt, true)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_DailySyncMoodSelector, {
          modelValue: _ctx.dailySync.feelingEmoji,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dailySync.feelingEmoji) = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateDailySync()))
          ]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_DailySyncAvailabilitySelector, {
          modelValue: _ctx.userSchedule,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSchedule) = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateDailySync()))
          ]
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_DailySyncTaskList, {
          modelValue: _ctx.tasks,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tasks) = $event)),
            _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateDailySync()))
          ],
          group: "my-tasks",
          class: _normalizeClass({ 'daily-sync-list-saving': _ctx.isSaving })
        }, null, 8, ["modelValue", "class"]),
        _hoisted_11,
        _createVNode(_component_AppTextEditor, {
          modelValue: _ctx.dailySync.message,
          "onUpdate:modelValue": [
            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dailySync.message) = $event)),
            _cache[9] || (_cache[9] = ($event: any) => (_ctx.onTeamTalkUpdated()))
          ],
          placeholder: "Anything else you'd like to share with your team?",
          class: _normalizeClass({ 'readyForEdit': !_ctx.editingTeamTalk }),
          editable: true,
          borderless: !_ctx.editingTeamTalk,
          onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingTeamTalk = true)),
          onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editingTeamTalk = false, _ctx.saveChangesToTeamTalk()))
        }, null, 8, ["modelValue", "class", "borderless"]),
        (_ctx.previouslyCompletedTasks?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["daily-sync-user-card__main__completed", { 'expanded': _ctx.expandCompletedTaskList }])
            }, [
              _createElementVNode("div", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.expandCompletedTaskList = !_ctx.expandCompletedTaskList)),
                class: "daily-sync-user-card__main__completed__header"
              }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.previouslyCompletedTasks.length) + " completed " + _toDisplayString(_ctx.previouslyCompletedTasks.length === 1 ? 'task' :
                  'tasks') + " since last sync", 1),
                _createVNode(_component_AppIcon, {
                  name: "arrow",
                  size: "12"
                })
              ]),
              (_ctx.expandCompletedTaskList)
                ? (_openBlock(), _createBlock(_component_DailySyncTaskList, {
                    key: 0,
                    modelValue: _ctx.previouslyCompletedTasks,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.previouslyCompletedTasks) = $event)),
                    editable: false
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_ReactionDisplay, {
        reactions: _ctx.dailySync.reactions
      }, null, 8, ["reactions"]),
      _createElementVNode("div", null, _toDisplayString(_ctx.dailySync.commentCount ?? 0) + " comments", 1)
    ]),
    _createVNode(_component_Conversation, {
      itemId: { teamId: _ctx.dailySync.teamId, userId: _ctx.dailySync.userId, date: _ctx.dailySync.date },
      itemType: _ctx.CommentType.DAILY_SYNC
    }, null, 8, ["itemId", "itemType"])
  ]))
}